import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Button,
  Checkbox,
  Grid,
  IconButton,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import HeaderComponent from "./processComponent/HeaderComponent";
import moment from "moment";
import {
  fcheck_null_undefine_replace_empty,
  getStatusStyleV1,
} from "../../Utility/Utilitys";
import { IMPUR01A_SummaryApi } from "../../Server/ApiV2";
import { vRdxUserInfo } from "../../Redux/roStore";
import ImportDetailModal from "./ImportDetailModal";
import CmpModal from "../../Component/Common/ReuseableComponent/CmpModal";
import { Set_WmsInnModelCheckbox_Init } from "./SliceImportPuchaseRequest";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import {
  DataGridPro,
  gridRowIdsSelector,
  useGridApiRef,
} from "@mui/x-data-grid-pro";
import { buildBrandArray } from "./ImportPurchaseAction";

const ImportPurchaseSummary = () => {
  const uMediaQuery = useMediaQuery("(max-width:390px)");
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const xMediaQuery = useMediaQuery("(max-width:950px)");
  const aMediaQuery = useMediaQuery("(max-width:1300px)");
  const status = ["All", "Enter", "Post"];
  const dispatch = useDispatch();
  const [summaryData, setSummaryData] = useState([]);
  const [open, setOpen] = useState(false);
  const [openFilterModal, setOpenFilterModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null); // Store full row data
  const [isPopModalDataChanged, setIsPopModalDataChanged] = useState(false);

  const LocWithRights = useSelector(
    (state) => state.SliceDB.value.Location.LocWithoutRights
  );
  const vRdxuserLoc = useSelector((state) => state.SliceGRNLocation.value);
  const [filterObj, setFilterObj] = useState({
    dateFrom: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      1
    ).toISOString(),
    dateTo: new Date(),
    location: vRdxuserLoc.length > 0 ? vRdxuserLoc[0]?.UID : [],
    status: "All",
  });

  const handleLoadBtn = () => {
    fonLoad();
    if (vMediaQuery) {
      setOpenFilterModal(false);
    }
  };
  // Convert CSV string to array
  const csvToArr = (csv) =>
    typeof csv === "string" && csv.trim()
      ? csv
          .split(",")
          .map((s) => s.trim())
          .filter(Boolean)
      : [];

  // Convert array to CSV string
  const arrToCsv = (arr) =>
    Array.isArray(arr) && arr.length ? arr.filter(Boolean).join(",") : "";

  const handleRowClick = (params) => {
    const row = params?.row ?? params;
    const sBrandArr = buildBrandArray(row.A_BrandCd, row.BrandName);

    const next = {
      ...row,
      Loc: csvToArr(row?.Loc),
      Group: csvToArr(row?.Group),
      sBrandArr,
    };

    setSelectedRow(next);
    setOpen(true);
  };

  const fNew = () => {
    setSelectedRow({
      TransId: 0,
      Loc: [],
      A_LocName: "",
      Date: new Date(),
      Group: [],
      A_GroupName: "",
      SubGroup: "",
      A_SubGroupName: "",
      Category: "",
      A_CategoryName: "",
      FromDate: new Date(new Date().getFullYear(), 0, 1),
      ToDate: new Date(),
      TransLoc: vRdxuserLoc.length > 0 ? vRdxuserLoc[0]?.UID : [],
      DocStatus: "ENTER",
      LeadDays: "",
      ForecastDays: "",
      AnalysisDays: "",
      EnBy: "",
      EnDt: "",
    });
    setOpen(true);

    setTimeout(() => {
      document.getElementsByName("Date")[0]?.focus();
    }, 200);
  };

  const apiRef = useGridApiRef();
  const handleExport = () => {
    apiRef.current.exportDataAsCsv({
      // ALL loaded rows (ignores selection)
      getRowsToExport: ({ apiRef }) => gridRowIdsSelector(apiRef),
      includeHeaders: true,
      utf8WithBom: true,
      // allColumns: true,
    });
  };

  const fFilter = () => {
    setOpenFilterModal(true);
  };
  
  const fonLoad = async (
    loc = filterObj?.location,
    status = filterObj?.status,
    fromdate = filterObj?.dateFrom,
    todate = filterObj?.dateTo
  ) => {
    const vRdxUserInfoObj = vRdxUserInfo();

    var obj = {
      FromDate: moment(fromdate).format("MM/DD/YYYY"),
      ToDate: moment(todate).format("MM/DD/YYYY"),
      TransLoc: loc,
      DocStatus: status,
      UserCd: vRdxUserInfoObj?.UserID,
    };

    let FinalObj = fcheck_null_undefine_replace_empty(obj);
    const resp = await IMPUR01A_SummaryApi(FinalObj);

    if (resp?.status === 200) {
      if (resp?.data?.ResultSet?.length > 0) {
        setSummaryData(resp?.data?.ResultSet);
      }
    } else {
      setSummaryData([]);
    }
  };

  useEffect(() => {
    fonLoad();
  }, []);

  return (
    <div className="div-container">
      <Box pt={vMediaQuery ? 0 : 2}>
        {vMediaQuery ? (
          <Grid container>
            <Grid item xs={6}>
              <Typography
                variant={vMediaQuery ? "subtitle2" : "h6"}
                gutterBottom
                color={"primary"}
                sx={{ fontWeight: 600, mt: 0.5 }}
              >
                Planning
              </Typography>
            </Grid>
            <Grid item xs={2} textAlign={"right"}>
              <Button
                variant="contained"
                sx={{
                  height: "30px",
                  mt: 0.5,
                  textTransform: "capitalize",
                }}
                onClick={fFilter}
              >
                Filter
              </Button>
            </Grid>
            <Grid item xs={3} textAlign={"right"}>
              <Button
                variant="contained"
                sx={{
                  height: "30px",
                  mt: 0.5,
                  textTransform: "capitalize",
                }}
                onClick={fNew}
              >
                New
              </Button>
            </Grid>
            <Grid item xs={1}>
              <Tooltip title="Export CSV" sx={{ mt: 0.5 }}>
                <IconButton color="primary" onClick={handleExport} size="small">
                  <DownloadOutlinedIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        ) : (
          <>
            <Typography
              variant="h6"
              gutterBottom
              color={"primary"}
              sx={{ fontWeight: 600 }}
            >
              Planning
            </Typography>

            <HeaderComponent
              fNew={fNew}
              status={status}
              filterObj={filterObj}
              setFilterObj={setFilterObj}
              vRdxDBLocation={vRdxuserLoc}
              handleExport={handleExport}
              handleLoadBtn={handleLoadBtn}
              setIsPopModalDataChanged={setIsPopModalDataChanged}
              //title ="planning" 

            />
          </>
        )}

        <Box
          sx={{
            mt: vMediaQuery ? 1 : 2,
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
            height: { xs: "75vh", sm: "60vh", md: "68vh", lg: "68vh" },
            width: "100%",
          }}
        >
          <DataGridPro
            rowHeight={30}
            headerHeight={40}
            apiRef={apiRef}
            rows={summaryData}
            getRowId={(v) => v.TransId}
            columns={[
              {
                field: "TransId",
                headerName: "TransID",
                width: xMediaQuery ? 60 : 80,
                align: "center",
                headerAlign: "center",
              },
              {
                field: "Date",
                headerName: "TransDate",
                width: xMediaQuery ? 80 : 90,
                valueFormatter: ({ value }) =>
                  moment(value).format("DD/MM/YYYY") == "Invalid date"
                    ? ""
                    : moment(value).format("DD/MM/YYYY"),
              },
              {
                field: "ExpiredDate",
                headerName: "ExpiryDate",
                width: xMediaQuery ? 80 : 90,
                valueFormatter: ({ value }) =>
                  moment(value).format("DD/MM/YYYY") == "Invalid date"
                    ? ""
                    : moment(value).format("DD/MM/YYYY"),
              },
              {
                field: "TransLoc_Name",
                headerName: "TransLocation",
                width: xMediaQuery ? 80 : 120,
              },
              {
                field: "DocStatus",
                headerName: "Status",
                width: 80,
                align: "center",
                headerAlign: "center",
                renderCell: (params) => {
                  const style = getStatusStyleV1(params.value);
                  return (
                    <div
                      style={{
                        ...style,
                        padding: "2px 8px",
                        borderRadius: "4px",
                        textAlign: "center",
                        width: "100%",
                        fontWeight: "bold",
                      }}
                    >
                      {params.value}
                    </div>
                  );
                },
              },

              {
                field: "LeadDays",
                headerName: "LeadDays",
                width: 80,
                align: "center",
                headerAlign: "center",
              },
              {
                field: "ForecastDays",
                headerName: "Forecast Days",
                width: 100,
                align: "center",
                headerAlign: "center",
              },

              {
                field: "FromDate",
                headerName: "AnalysisFromDate",
                width: 95,
                valueFormatter: ({ value }) =>
                  moment(value).format("DD/MM/YYYY") == "Invalid date"
                    ? ""
                    : moment(value).format("DD/MM/YYYY"),
              },
              {
                field: "ToDate",
                headerName: "AnalysisToDate",
                width: 95,
                valueFormatter: ({ value }) =>
                  moment(value).format("DD/MM/YYYY") == "Invalid date"
                    ? ""
                    : moment(value).format("DD/MM/YYYY"),
              },

              {
                field: "AnalysisDays",
                headerName: "Analysis Days",
                width: xMediaQuery ? 80 : 100,
                align: "center",
                headerAlign: "center",
              },

              {
                field: "GroupName",
                headerName: "Group",
                width: xMediaQuery ? 100 : 200,
              },
              {
                field: "LocName",
                headerName: "Analysis Location",
                width: aMediaQuery ? 100 : 200,
              },

              {
                field: "EnByName",
                headerName: "Created By",
                width: 150,
              },
              {
                field: "EnDts",
                headerName: "Created Date",
                width: 95,
                valueFormatter: ({ value }) =>
                  moment(value).format("DD/MM/YYYY") == "Invalid date"
                    ? ""
                    : moment(value).format("DD/MM/YYYY"),
              },
            ]}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0
                ? "mui-even-row"
                : "mui-odd-row"
            }
            sx={{
              border: 1,
              borderColor: "primary.light",
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#0d73bb",
                color: "white",
              },
            }}
            hideFooter
            onRowClick={handleRowClick}
          />
        </Box>
        <CmpModal
          open={open}
          onClose={() => {
            if (isPopModalDataChanged) {
              fonLoad();
              setIsPopModalDataChanged(true);
            }
            setIsPopModalDataChanged(false);
            setOpen(false);
            dispatch(Set_WmsInnModelCheckbox_Init());
          }}
          title="Import Detail Modal"
          width={"95%"}
          height={"86vh"}
          component={
            <ImportDetailModal
              fOnClose={() => {
                fonLoad();
                setOpen(false);
                dispatch(Set_WmsInnModelCheckbox_Init());
              }}
              arrToCsv={arrToCsv}
              fNew={fNew}
              selectedRow={selectedRow}
              vRdxDBLocation={LocWithRights}
              vRdxuserLoc={vRdxuserLoc}
              setIsPopModalDataChanged={setIsPopModalDataChanged}
              aMediaQuery={vMediaQuery}
            />
          }
        />

        {vMediaQuery && (
          <CmpModal
            open={openFilterModal}
            onClose={() => setOpenFilterModal(false)}
            title="Filter"
            width={"95%"}
            height={"auto"}
            component={
              <HeaderComponent
                closeModal={() => setOpenFilterModal(false)}
                status={status}
                handleLoadBtn={handleLoadBtn}
                filterObj={filterObj}
                setFilterObj={setFilterObj}
                vRdxDBLocation={vRdxuserLoc}
                 //                            title ="planning" 

              />
            }
          />
        )}
      </Box>
    </div>
  );
};

export default ImportPurchaseSummary;





